const apiBase = process.env.REACT_APP_HOST_API_KEY;

export const getImgSrc = (imgId) => {
  const url =  `${apiBase}public/attachments/${imgId}`;
  return url;
};
